// extracted by mini-css-extract-plugin
export default {"box":"loginPage_box__g6k78","box__form":"loginPage_box__form__xdc1r"};